/**
 * The web app's refresh cookie (mm-be `api/v5/auth/cookies.py`).
 *
 * Sending `X-Auth-Cookie: 1` opts a request into cookie mode: login and social
 * answer `refresh: null` and set an HttpOnly `mm_refresh` cookie scoped to
 * `/api/v5/auth/`; refresh reads that cookie and ignores the body; logout
 * clears it. Page scripts can never read the cookie, so an XSS bug cannot take
 * the week-long credential. The header is also mm-be's CSRF guard: another
 * site cannot add it without a CORS preflight that mm-be refuses.
 *
 * Every cookie-mode call must also send `credentials: 'include'`. In dev the
 * Vite proxy keeps `/api` same-origin, but a build calls the API's own origin,
 * and a cross-origin response may only set or send a cookie when the request
 * asked for credentials.
 *
 * Its own module because two callers need it and neither may import the
 * other: features/auth/api/authService.ts (login, social), and the bare-fetch
 * refresh and logout in lib/auth/store.ts.
 */
export const AUTH_COOKIE_HEADER = 'X-Auth-Cookie'
